import * as React from 'react'
import {graphql} from 'react-apollo'
import {getEmployeeDetailsFromIAM} from '../queries/employeeQuery'
import {checkObjProps} from './genericUtils'

const graphqlDynamicQueryGenerator = (query: any, config: any) => {
  return (component: any) => {
    return React.memo((props: any) => {
      return React.createElement(
        graphql(query(props), config)(component),
        props
      )
    })
  }
}

const writeToCache = (employee: any) => {
  sessionStorage.setItem('dateFormat', employee.dateFormat || 'DD.MM.YYYY')
  sessionStorage.setItem('userLocale', employee.userLocale || 'de-DE')
}

/**
 * returns a parameter value of an String.
 * use this when you need to get citrixId, return value of an string or null.
 * ex -: if we want to check conditions (Apollo<Client>,Router<match>) and return Object,
 * we can use getUserCitrixId(Apollo<Client>,Router<match>);
 *
 * @param1 Object   obj    object to be parsed
 * @param2 Object   obj    object to be parsed
 * @returns "g9968"  value of the object property
 */
const getUserCitrixId = (empId: any, sixtId: any) => {
  const otherProfileEmpId = empId
  const isOtherUser = !!otherProfileEmpId && otherProfileEmpId !== sixtId

  return {
    empId,
    isOtherUser,
    isSysAdmin: false, // Not available in IAM, using default
  }
}

const getCitrixId = (client: any) => {
  try {
    const {
      getEmployeeDetailsFromIAM: {sixtId: citrixId},
    } = client.readQuery({
      query: getEmployeeDetailsFromIAM,
      variables: {
        empId: null,
      },
    })
    return {citrixId}
  } catch (err) {
    console.log(err)
  }
  return {citrixId: ''}
}
/**
 *
 * @param data graphql data for getSchemaPickListValuesBasedOnCountry
 * @returns array of picklist option
 */
const pickListMappingFn = (data: any) => {
  return checkObjProps(
    data,
    ['getSchemaPickListValuesBasedOnCountry', 'picklistOptions'],
    []
  )
}

export {
  getCitrixId,
  getUserCitrixId,
  graphqlDynamicQueryGenerator,
  writeToCache,
  pickListMappingFn,
}
